import { SignalingSocket } from 'services/signaling';
import { call, select, delay } from 'redux-saga/effects';
import { pluginHandleAttachFailed } from 'features/streaming/actions';
import { selectIsSystemSession } from 'features/application/selectors';

export function* handlePluginAttachFailureSaga(
  action: ReturnType<typeof pluginHandleAttachFailed>
) {
  const isSystemSession: boolean = yield select(selectIsSystemSession);
  if (isSystemSession) {
    // avoid potential race conditions with non-initialized recorder
    yield delay(5000);

    yield call(SignalingSocket.close, undefined, action.payload);
  }
}
